import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// To use this component, it should be included in the root of an element that
// has a position defined (e.g. position: relative) so that it can fill the
// space using absolute positioning

const ExpandableModalPanel = t0 => {
  const $ = _c(11);
  const {
    children,
    isOpen,
    onOverlayClick: t1
  } = t0;
  const onOverlayClick = t1 === undefined ? _temp : t1;
  const t2 = !isOpen;
  let t3;
  if ($[0] !== isOpen || $[1] !== t2) {
    t3 = classNames("md:hidden bottom-0 flex-col left-0 absolute right-0 top-0 z-[1]", {
      hidden: t2,
      flex: isOpen
    });
    $[0] = isOpen;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <div className="bg-white">{children}</div>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onOverlayClick) {
    t5 = <button label="button" type="button" className="flex-1" onClick={onOverlayClick} />;
    $[5] = onOverlayClick;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
ExpandableModalPanel.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.objectOf(PropTypes.node),
  onOverlayClick: PropTypes.func
};
export default ExpandableModalPanel;
function _temp() {}